import {Pipe, PipeTransform} from "@angular/core"

@Pipe({
    name: "cmDuration",
})
export class DurationFromMillisecondsPipe implements PipeTransform {
    transform(durationInMilliseconds: number | undefined | null): string {
        if (durationInMilliseconds === null || durationInMilliseconds === undefined) {
            return "-"
        }
        const totalSeconds = Math.floor(durationInMilliseconds / 1000)
        const days = Math.floor(totalSeconds / 86400)
        const hours = Math.floor((totalSeconds % 86400) / 3600)
        const minutes = Math.floor((totalSeconds % 3600) / 60)
        const seconds = totalSeconds % 60
        const hms = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
        return days > 0 ? `${hms} (+${days} days)` : hms
    }
}
